import React, { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import { HashLink } from "react-router-hash-link";
import terrain_pattern_lg from "../../assets/images/terrain-pattern-lg.webp";
import NCJUA_incentive from "../../assets/images/services/NCJUA-incentive.jpg";
import coating_division from "../../assets/images/services/coating-division.png";
import solar_roof from "../../assets/images/services/solar-roof.jpg";
import fortified_roof from "../../assets/images/services/fortified-roof.jpg";

const services = [
  {
    header: "NCJUA Incentives for Fortified Roofs",
    description:
      "NCJUA in North Carolina provides financial incentives, including up to $5,000 for insurance deductible reimbursement and a $10,000 grant for roof upgrades with a FORTIFIED™ Roof.",
    image: NCJUA_incentive,
    link: "/services#NCJUA",
  },
  {
    header: "Coatings Division",
    description:
      "Our Coating Division’s Eterna-Sil Premium Silicone Coatings extend roof life by enhancing durability, energy efficiency, and waterproofing, eliminating costly replacements.",
    image: coating_division,
    link: "/services#CoatingDivision",
  },
  {
    header: "GAF Timberline Solar™",
    description:
      "GAF Timberline Solar™ integrates solar technology into roof shingles, offering a sleek, low-profile, energy-efficient roofing system that generates clean, renewable power while maintaining durability and aesthetic appeal.",
    image: solar_roof,
    link: "/services#Solar",
  },
  {
    header: "IBHS Fortified Roof & Fortified Roof Program",
    description:
      "The IBHS Fortified Roof uses reinforced materials and advanced installation techniques to significantly reduce storm-related damage and lower repair and insurance claim costs.",
    image: fortified_roof,
    link: "/services#FortifiedRoof",
  },
];

export default function Example() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // reveal the section heading and intro
      sr.reveal("#additional-services h2, #additional-services p", {
        origin: "top",
        distance: "20px",
        duration: 600,
        interval: 150,
      });

      // stagger each service card
      sr.reveal("#additional-services .reveal-card", {
        origin: "bottom",
        distance: "30px",
        duration: 700,
        interval: 200,
        delay: 300,
      });
    }
  }, []);

  return (
    <div
      id="additional-services"
      style={{ backgroundImage: `url(${terrain_pattern_lg})` }}
      className="bg-gray-50 py-24 sm:py-32 bg-center z-50"
    >
      <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
        <h2 className="font-united_sans_sm text-center text-base/7 font-semibold text-[#D2B48C]">
          WE OFFER MORE THAN THE BASICS
        </h2>
        <p className="font-united_sans_lg mx-auto mt-2 max-w-lg text-balance text-center text-4xl font-semibold tracking-tight text-gray-950 sm:text-5xl">
          Additional Services
        </p>
        <div className="mt-10 grid gap-4 sm:mt-16 lg:grid-cols-4">
          {services.map((service, index) => (
            <div key={index} className="relative reveal-card">
              {/* added a fixed height (adjust the value as needed) */}
              <div className="relative w-full sm:h-auto lg:h-auto xl:h-[500px] overflow-hidden rounded-3xl bg-gray-900 px-6 pb-9 pt-6 shadow-2xl sm:px-12 lg:px-8 lg:pb-8 xl:px-10 xl:pb-10">
                <img
                  alt={service.header}
                  src={service.image}
                  className="absolute inset-0 w-full h-full object-cover brightness-125 saturate-0"
                />
                <div className="absolute inset-0 bg-gray-900 mix-blend-multiply" />
                <div
                  aria-hidden="true"
                  className="absolute left-1/2 top-1/2 -ml-16 transform -translate-x-1/2 -translate-y-1/2 blur-3xl"
                >
                  <div
                    style={{
                      clipPath:
                        "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
                    }}
                    className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff7979] to-[#ff0000] opacity-40"
                  />
                </div>
                <figure className="relative isolate flex flex-col h-full">
                  <div className="px-0 pt-4">
                    <div className="min-h-[4rem] flex items-center justify-center">
                      <h3 className="font-united_sans_lg text-center mt-0 text-white text-pretty text-2xl font-bold">
                        {service.header}
                      </h3>
                    </div>
                  </div>
                  <div className="px-0 pb-9 pt-6">
                    <p className="text-white">{service.description}</p>
                  </div>
                  <div className="mt-auto text-right">
                    <HashLink
                      smooth
                      to={service.link}
                      className="text-sm/6 font-semibold text-white"
                    >
                      Learn more <span aria-hidden="true">→</span>
                    </HashLink>
                  </div>
                </figure>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
